import { CATEGORY_NAMES, type Card, RANK_CHARS, categoryOf, evaluateBest } from '@tctp/engine/browser';

const BASE = 13;

/** "PAIR (9)", "TWO PAIR (K)", "HIGH CARD (A)" for 5–7 cards; null with fewer. */
export function handTag(cards: Card[]): string | null {
  if (cards.length < 5 || cards.length > 7) return null;
  const strength = evaluateBest(cards);
  const top = Math.floor(strength / BASE ** 4) % BASE;   // the first packed tiebreak: the category's top rank
  const r = RANK_CHARS[top]!;
  return `${CATEGORY_NAMES[categoryOf(strength)]!.toUpperCase()} (${r === 'T' ? '10' : r})`;
}
